module.exports = __webpack_public_path__ + "img/DegreeDayScreenshot.94736e55.png";